module.exports = __webpack_public_path__ + "media/application/images/2018/2018-independent-icon-930d7bb9ad43684504dba94ac851824a.jpg";